app.service('templatingService', ['crudService', '$templateRequest', '$cookies', function (crudService, $templateRequest, $cookies) {
    /**
     * Service de templating pour les routes
     * @type {Object}
     */
    return {
        /**
         * Rend un template selon le type d'utilisateur (QualiEstate ou QualiEasy)
         * @param  templateFile
         */
        render: function (templateFile) {
            // Info : la session est suppr à la reco
            // Recuperation de l'application en cours en session
            var app = $cookies.getObject('app');
            var that = this;
            if (angular.isDefined(app)) return that.get(app.slug, templateFile, $templateRequest);// Si infos dans session
            else {
                return crudService.get('/account/app').then(function (response) {
                    $cookies.putObject('app', response); // Sauvegarde en session
                    return that.get(response.slug, templateFile, $templateRequest);
                }, function () {
                    return that.get('', templateFile, $templateRequest);
                });
            }
        },


        /**
         * Recuperation du contenu d'un template selon l'appli ( qualieasy / qualiestate)
         */
        get: function (app, templateFile, $templateRequest) {
            return $templateRequest("/templates/" + app + templateFile).then(function (template) {
                return template;
            }, function () {
                // template non trouvé
                return '';
            });
        }
    };
}]);